import {UserQueryDtoInterface} from './dto/user-query-dto';
import {FilterUserQueryDto} from './dto/filter-user-query-dto';
import {BaseUserTableService} from '../base-user-table.service';
import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {MessageService} from '../../../messages/message.service';
import {SearchService} from '../../../search/search.service';

@Injectable({
  providedIn: 'root'
})
export class UserQueriesService extends BaseUserTableService<UserQueryDtoInterface, FilterUserQueryDto> {

  private readonly baseUrl = 'portalApiUrl/omnis/user/query';
  private readonly notificationUrl ='portalApiUrl/omnis/user/emailnotification/notificationupdate';

  constructor(protected httpClient: HttpClient, private messageService: MessageService,
              private searchService: SearchService) {
    super(httpClient);
  }

  getBaseUrl(): string {
    return this.baseUrl;
  }

  async handleSaveUserQuery(value: UserQueryDtoInterface, token: string): Promise<UserQueryDtoInterface> {
    try {
      value.searchQuery = this.searchService.dumpSearchQuery();
      const saveResult = await this.update(value, token).toPromise();
      if (saveResult){
        value.id = saveResult;
        this.messageService.successMessage('UserQuery.persisted', 'UserQuery.persisted.desc');
        return value;
      }
    }catch (error1) {
      console.log(error1);
    }
    this.messageService.errorMessage('UserQuery.persisted.error', 'UserQuery.persisted.desc.error');
    return null;
  }

  async loadEmailNotificationPeriod(token: string) {
      return await this.http.get<any>(this.notificationUrl, {headers: this.createHeaders(token)}).toPromise();
  }

  async saveEmailNotificationPeriod(timePeriod: string, language: string, token: string) {
    const result = await this.http.post<any>(this.notificationUrl, {timePeriod, language},{headers: this.createHeaders(token)}).toPromise();

    if (result) {
      this.messageService.successMessage('UserQuery.persisted', 'UserQuery.persisted.time');
    } else {
      this.messageService.errorMessage('UserQuery.persisted.error', 'UserQuery.persisted.desc.time');
    }
    return result;

  }

  protected normalizeToQueryParams(filterDto: FilterUserQueryDto): { [p: string]: string | string[] } {
    if (!filterDto.title){
      filterDto.title = '';
    }
    if (!filterDto.note){
      filterDto.note = '';
    }
    if (!filterDto.itemCountFrom){
      filterDto.itemCountFrom = '';
    }
    if (!filterDto.itemCountTo){
      filterDto.itemCountTo = '';
    }
    if (!filterDto.tagsRaw){
      filterDto.tagsRaw = '';
    }
    return {
      title: filterDto.title, note: filterDto.note, itemCountFrom: filterDto.itemCountFrom,
      itemCountTo: filterDto.itemCountTo, tagsRaw: filterDto.tagsRaw};
  }




}
